import { render, staticRenderFns } from "./CountryReport.vue?vue&type=template&id=20097894&scoped=true"
import script from "./CountryReport.vue?vue&type=script&lang=js"
export * from "./CountryReport.vue?vue&type=script&lang=js"
import style0 from "./CountryReport.vue?vue&type=style&index=0&id=20097894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20097894",
  null
  
)

export default component.exports